import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from '../../components/shared.module';
import { BadgePopupComponent } from './components/badge-popup/badge-popup.component';
import { BibleVersePopupComponent } from './components/bible-verse-popup/bible-verse-popup.component';
import { CategoryPopupComponent } from './components/category-popup/category-popup.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { CreateGroupPopupComponent } from './components/create-group-popup/create-group-popup.component';
import { CreatePostPopupComponent } from './components/create-post-popup/create-post-popup.component';
import { DeleteAccountPopupComponent } from './components/delete-account-popup/delete-account-popup.component';
import { EditPinnedGroupPopupComponent } from './components/edit-pinned-group-popup/edit-pinned-group-popup.component';
import { EnterInfoPopupComponent } from './components/enter-info-popup/enter-info-popup.component';
import { GroupInvitePopupComponent } from './components/group-invite-popup/group-invite-popup.component';
import { GroupManagePopupComponent } from './components/group-manage-popup/group-manage-popup.component';
import { GroupMemberPopupComponent } from './components/group-member-popup/group-member-popup.component';
import { LogoutPopupComponent } from './components/logout-popup/logout-popup.component';
import { ReportPostPopupComponent } from './components/report-post-popup/report-post-popup.component';
import { SearchPopupComponent } from './components/search-popup/search-popup.component';
import { SharePostPopupComponent } from './components/share-post-popup/share-post-popup.component';
import { ShareProfilePopupComponent } from './components/share-profile-popup/share-profile-popup.component';
import { SuccessPopupComponent } from './components/success-popup/success-popup.component';
import { TestimonyPopupComponent } from './components/testimony-popup/testimony-popup.component';
import { VerifyEmailPopupComponent } from './components/verify-email-popup/verify-email-popup.component';

@NgModule({
    declarations: [
        BadgePopupComponent,
        BibleVersePopupComponent,
        CategoryPopupComponent,
        ConfirmationPopupComponent,
        CreateGroupPopupComponent,
        CreatePostPopupComponent,
        DeleteAccountPopupComponent,
        EditPinnedGroupPopupComponent,
        EnterInfoPopupComponent,
        GroupInvitePopupComponent,
        GroupManagePopupComponent,
        GroupMemberPopupComponent,
        LogoutPopupComponent,
        ReportPostPopupComponent,
        SearchPopupComponent,
        SharePostPopupComponent,
        ShareProfilePopupComponent,
        SuccessPopupComponent,
        TestimonyPopupComponent,
        VerifyEmailPopupComponent,
    ],
    imports: [CommonModule, MatDialogModule, MatMenuModule, ReactiveFormsModule, SharedModule],
})
export class PopupModule {}
